"use strict";

(function () {
    jQuery(document).ready(function () {
        $('#menu-overflow').on('click', function(){
            closeMobileHamburger();
        });
    });
})(jQuery);

function closeSearchInput() {
    $('.search-input').fadeOut(300);
}
function openSearchInput() {
    $('.search-input').fadeIn(300);
    $('.search-input input[type="text"]').focus();
}
function openDesktopHamburger() {
    $('body').css('overflow', 'hidden');
    openSubmenu(2,1);

    let menuToTop = $('#hamburger-menu-mobile').offset().top;
    let announcement_height = $('#announcement_top').height();

    if(menuToTop == announcement_height){
        $('#hamburger-menu-mobile').css('top', `-${announcement_height}px`);
    }else{
        $('#hamburger-menu-mobile').css('top', `0px`);
    }

    $('#menu-overflow').fadeIn(500);
    let left = $('#hamburger-menu-mobile').offset().left;
    $("#hamburger-menu-mobile").css({left: left}).animate({"left":"0px"}, "slow");


}
function openMobileHamburger() {
    $('body').css('overflow', 'hidden');
    let container_height = $('#menu_level_1').height()+40;

    let menuToTop = $('#hamburger-menu-mobile').offset().top;
    let announcement_height = $('#announcement_top').height();

    if(menuToTop == announcement_height){
        $('#hamburger-menu-mobile').css('top', `-${announcement_height}px`);
    }else{
        $('#hamburger-menu-mobile').css('top', `0px`);
    }

    $('#hamb_menu_container').css('height', container_height);
    $('#menu-overflow').fadeIn(500);
    let left = $('#hamburger-menu-mobile').offset().left;
    $("#hamburger-menu-mobile").css({left: left}).animate({"left":"0px"}, "slow");
}
function closeMobileHamburger() {
    $('body').css('overflow', 'visible');
    let left = $('#hamburger-menu-mobile').offset().left;
    $('#menu-overflow').fadeOut(500);
    $("#hamburger-menu-mobile").css({left: left}).animate({"left":"-360px"}, "slow");
    setTimeout(function(){
        $('#hamburger-menu-mobile').css('top', `0px`);
    }, 800);
}

function setHambMenuHeight(level) {
    setTimeout(function() {
        let container_height = $(`#menu_level_${level}`).height() + 40;
        $('#hamb_menu_container').css('height', container_height);
    }, 500);
}

function openSubmenu(level, counter) {
    let left = $('#hamburger-menu-mobile').offset().left;
    let right = $('#hamburger-menu-mobile').offset().right;
    setHambMenuHeight(level);

    console.log(counter);

    if(level==2){
        $('.submenu-links-2').hide();
        $(`#submenu_level_2_${counter}`).show();
        $('#menu_level_1').css({left: left}).animate({"left":"-360px"}, "slow");
        $('#menu_level_2').css({right: right}).animate({"right":"0px"}, "slow");
    }
    if(level==3){
        $('.submenu-links-3').hide();
        $(`#submenu_level_3_${counter}`).show();
        $('#menu_level_2').css({left: left}).animate({"left":"-360px"}, "slow");
        $('#menu_level_3').css({right: right}).animate({"right":"0px"}, "slow");
    }
}

function closeSubmenu(level) {
    let right = $('#hamburger-menu-mobile').offset().right;

    if(level==2){
        let container_height = $('#menu_level_1').height()+40;
        $('#hamb_menu_container').css('height', container_height);

        $('#menu_level_1').css({left: "-360px"}).animate({"left":"0px"}, "slow");
        $('#menu_level_2').css('left','unset').css({right: right}).animate({"right":"-360px"}, "slow");
    }
    if(level==3){
        let container_height = $('#menu_level_2').height()+40;
        $('#hamb_menu_container').css('height', container_height);

        $('#menu_level_2').css({left: "-360px"}).animate({"left":"0px"}, "slow");
        $('#menu_level_3').css({right: right}).animate({"right":"-360px"}, "slow");
    }
}

function submitSearchForm(type) {
    let search_w = $(`#search_w_${type}`).val();
    if(search_w!=''){
        document.location.href= `/search?type=product,article,page&q=${search_w}`;
    }
}

function selectColorImage(color_value) {
    $(`.tmb-desktop-images a[data-img-variant-option1="${color_value}"]`).click();
}

